import React from 'react'
import { useTranslation } from 'react-i18next'

import { Flash } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'

import Styles from './AutoAcceptBanner.module.scss'

const AutoAcceptBanner: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={Styles.banner} data-testid="auto-accept-banner">
      <Flash width={12} height={12} className={Styles.icon} />
      <Text variant="nextCaption" weight="semiBold" className={Styles.label}>
        {t('auto-accept.banner.label')}
      </Text>
    </div>
  )
}

export default AutoAcceptBanner
